import { LinearProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";

import classes from "./Progress.module.css";
import MyDivider2 from "../MyDivider2";

export default function ProgressBar({
  color = "primary",
  txt = null,
  height = 2,
  show = false,
  ...props
}) {
  // use either props.show or props.open
  if (!show && !props.open) return <MyDivider2 height={height} />;

  return (
    <div className={classes.progressBar} style={{ height: height }}>
      {txt && (
        <Typography variant="body2" color="primary" className="noPrint" align="center">
          {txt}
        </Typography>
      )}
      <div style={{ flexGrow: 1 }}>
        <LinearProgress color={color} sx={{ height: height, opacity: "0.7" }} {...props} />
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  show: PropTypes.bool,
  open: PropTypes.bool,
  txt: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
};
